























import { Component, Vue, Watch } from "vue-property-decorator";
import login from "./login.vue";
import accplogin from "./accplogin.vue";
import logRegist from "./logRegist.vue";
import accout from "./accout.vue";
import forgotpwd from "./forgotpwd.vue";

@Component({
  components: {
    login,
    accplogin,
    logRegist,
    accout,
    forgotpwd,
  },
})
export default class Home extends Vue {
  public tabArr = ["login", "accplogin", "logRegist", "accout", "forgotpwd"];
  // 初始 账号密码登录 登录/注册 注册账号 忘记密码-重新设置密码
  public tabCom = "login";
  public modal2 = false;
  public status = true;
  public active = 0;
  public objData: any = "";

  public mounted() {
    this.getLoginMethod();
  }
  public getLoginMethod() {
    const loginMethod = localStorage.getItem("loginMethod");
    if (loginMethod === "password") {
      this.active = 1;
      this.tabCom = "accplogin";
    } else if (loginMethod === "note") {
      this.active = 2;
      this.tabCom = "logRegist";
    } else {
      this.active = 0;
      this.tabCom = "login";
    }
  }
  public login(val) {
    this.active = val;
    this.tabCom = this.tabArr[this.active];
  }
  public loginShow(val) {
    const data = {
      username: val.username,
      password: val.password,
      loginShow: 8,
    };
    this.objData = data;
  }
  public onCancel() {
    if (!this.modal2) {
      sessionStorage.removeItem("modal");
    } else {
      if (this.active == 1) {
        this.$fn.userRecord(3100, 1);
      } else if (this.active == 2) {
        this.$fn.userRecord(3000, 1);
      }
    }
    this.getLoginMethod();
  }
}
